import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import i18nHelper from "@/core/services/i18n.service";
import {Formatter} from "@/core/services/formatter.service";

export default class ContinuousAuctionInvoiceModel extends BaseModel {
  uuid = null;
  paddle_number = null;
  lot_no = null;
  shipping_address_uuid = null;
  is_exported = null;
  is_tax_applied = null;
  is_registered_business = null;
  enable_shipping = false;
  shipping_amount = null;
  shipping_vat = null;
  shipping_taxable = null;
  shipping_tracking_code = null;
  preferred_language_code = null;
  invoiced_financial_items = [];
  miscellaneous_items = [];
  complaint_status = null
  tax_rate = null;
  date = Formatter.getCurrentDate();
  exclude_from_auto_payments = null;
  static TRANSLATABLE_FIELDS = [];

  rules = {
    preferred_language_code: 'required',
  };

  attributeLabels = {
    paddle_number: i18n.t('Paddle Number'),
    shipping_address_uuid: i18n.t('Shipping Address'),
    is_exported: i18n.t('Exported'),
    is_tax_applied: i18n.t('Apply VAT'),
    is_registered_business: i18n.t('Exported outside EU'),
    date: i18n.t('Date'),
    type: i18n.t('Type'),
    branch: i18n.t('Branch'),
    status: i18n.t('Status'),
    auction: i18n.t('Auction'),
    currency: i18n.t('Currency'),
    customer: i18n.t('Customer'),
    invoice_no: i18n.t('Invoice'),
    deposit_reservations: i18n.t('Deposit Reservation'),
    eligible_for_online_payments: i18n.t('Eligible for online payments'),
    shipping_amount: i18n.t('Amount'),
    shipping_taxable: i18n.t('Taxable'),
    preferred_language_code: i18n.t('Preferred Language'),
    lot_no: i18n.t('Lot Number'),
    complaint_status: i18n.t('Complaint Status'),
    tax_rate: i18n.t('Tax Rate'),
    exclude_from_auto_payments: i18n.t('Exclude from Auto-Payments'),
  };

  attributeHints = {
    preferred_language_code: i18n.t('Invoice template will be created according to the selected language'),
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    // Enable shipping checkbox if amount is present and is more than 0
    if (this.shipping_amount && this.shipping_amount > 0) {
      this.enable_shipping = true;
    }

    this.initTranslatableFields(this);
    this.preferred_language_code = this.preferred_language_code || i18nHelper.getMasterLanguage().key;
  }
}

defineTranslatableProperties(ContinuousAuctionInvoiceModel);
